<template>
  <a-modal
    title="一键导入"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    width="auto"
    centered
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    okText="保存"
    :getContainer="getContainer"
  >
    <div class="content">
      <div class="content1">
        <FormItem label="分包单位">
          <a-select
            size="large"
            show-search
            style="width: 100%"
            placeholder="请选择所属单位"
            option-filter-prop="children"
            :filter-option="filterOption"
            v-model="company_id"
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option :value="v.id" v-for="v in company_arr" :key="v.id">
              {{ v.name }}
            </a-select-option>
          </a-select>
        </FormItem>
        <br />
        <SelectFile ref="SelectFile" @change="specifiName" />
        <div v-if="p" style="margin-top: 5px">
          已读取有效数据条数：{{ batchArray.length }} 条
        </div>
        <div class="downloadFile" @click="downloadFile">
          <a-icon type="download" style="color: #0073ff" />
          下载模板
        </div>
      </div>
      <div class="content2" v-if="batchArray.length > 0">
        <div>待保存列表：</div>
        <!-- <div>(已存在待保存列表的文件会帮您自动过滤)</div> -->
        <a-list item-layout="horizontal" :data-source="batchArray">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta>
              <a slot="title" style="color: #000">{{ item.name }}</a>
              <div slot="description" class="description">
                <div class="left">
                  <div>{{ item.id_no }}</div>
                  <div>性别：{{ item.gender == 1 ? "男" : "女" }}</div>
                </div>
                <div class="del">
                  <a @click="delFile(index)">
                    <a-icon
                      type="close-circle"
                      style="color: red; font-size: 18px"
                    />
                  </a>
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { handleFileUpload, saveExcel } from "@/utils/os";
import { personFileBatch } from "@/utils/exportFile";
import { isDateOrDateTime, excelTimeFormat } from "@/utils/util";
import SelectFile from "@/components/SelectFile/index";
import { companyAll } from "@/request/company";
import { batchAdd } from "@/request/person";
import FormItem from "@/components/FormItem/index";
export default {
  components: { SelectFile, FormItem },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      p: "",
      company_id: undefined,
      batchArray: [],
      company_arr: [],
    };
  },
  methods: {
    init() {
      this.visible = true;
      companyAll().then((res) => {
        this.company_arr = res.data;
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //删除上传的文件
    delFile(index) {
      this.batchArray.splice(index, 1);
    },
    validateIDCard(idCard) {
      // 正则表达式校验
      var regex =
        /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[0-1])\d{3}[\dXx]$/;
      if (!regex.test(idCard)) {
        return false;
      }

      // 地区码校验
      // TODO: 进行地区码校验的逻辑

      // 出生日期校验
      var year = parseInt(idCard.substr(6, 4));
      var month = parseInt(idCard.substr(10, 2));
      var day = parseInt(idCard.substr(12, 2));
      var date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        return false;
      }

      // 顺序码校验
      // TODO: 进行顺序码校验的逻辑

      // 校验码校验
      var factors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var checksum = 0;
      for (var i = 0; i < 17; i++) {
        checksum += parseInt(idCard.charAt(i)) * factors[i];
      }
      var mod = checksum % 11;
      var checkCodeMap = {
        0: "1",
        1: "0",
        2: "X",
        3: "9",
        4: "8",
        5: "7",
        6: "6",
        7: "5",
        8: "4",
        9: "3",
        10: "2",
      };
      var checkCode = checkCodeMap[mod];

      return idCard.charAt(17).toUpperCase() === checkCode;
    },
    extractInfoFromIDCard(idCard) {
      var info = {};

      // 提取出生日期
      var year = idCard.substr(6, 4);
      var month = idCard.substr(10, 2);
      var day = idCard.substr(12, 2);
      var date = year + "-" + month + "-" + day;
      info.birthDate = date;

      // 计算年龄
      var birthDate = new Date(date);
      var today = new Date();
      var age = today.getFullYear() - birthDate.getFullYear();
      var monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      info.age = age;

      // 提取性别
      var genderCode = idCard.charAt(16);
      info.gender = genderCode % 2 === 0 ? "2" : "1";

      return info;
    },
    //选择的文件地址回调
    specifiName($event) {
      console.log("选择的文件地址回调");
      //   const hide = this.$message.loading("读取中···", 0);
      this.p = document.getElementById("open").files[0].path;
      const is_ = this.isTableFile(this.p);
      if (!is_) {
        $event.srcElement.value = ""; //及时清空
        return this.$message.warning("请选择 .xlsx、.xls 或 .csv 结尾的文件");
      }
      handleFileUpload($event).then((jsonData) => {
        jsonData.splice(0, 1);
        console.log(jsonData);
        let ok = [];
        for (let i = 0; i < jsonData.length; i++) {
          let obj = jsonData[i];
          let is_ok = true;
          for (let k = 0; k < obj.length; k++) {
            const item = obj[k];
            console.log(item, 'item')
            const must = personFileBatch[k].must; //当前数据是否必填
            if (!item && must) {
              is_ok = false;
              continue;
            }
          }
          console.log(JSON.parse(JSON.stringify(obj)), "obj");
          const id_no = obj[1]; //身份证号
          const ok_id_no = this.validateIDCard(id_no);
          if (!ok_id_no) {
            this.$notification["error"]({
              duration: 10,
              message: `${obj[0]} 身份证号码有误`,
            });
            continue;
          }
          //校验通过的数据
          if (is_ok) {
            const gender = this.extractInfoFromIDCard(id_no).gender;
            const birthday = this.extractInfoFromIDCard(id_no).birthDate;
            const age = this.extractInfoFromIDCard(id_no).age;
            console.log("有");
            let a = {};
            let specialRule = true;
            for (let index = 0; index < personFileBatch.length; index++) {
              const v = personFileBatch[index];
              if (v.cellDates) {
                //是否有日期格式数据
                const time = excelTimeFormat(obj[index], "YYYY-MM-DD");
                console.log("日期", time);
                if (isDateOrDateTime(time) === false) {
                  specialRule = false;
                } else {
                  a[v.key] = time;
                }
              } else {
                a[v.key] = obj[index];
              }
            }
            if (specialRule)
              ok.push({ ...a, gender: gender, birthday: birthday, age: age });
          }
        }
        console.log(JSON.parse(JSON.stringify(ok)));
        this.$message.success("读取成功");
        this.batchArray = ok;
      });
      $event.srcElement.value = ""; //及时清空
    },
    isTableFile(url) {
      // 在正则表达式中使用 $ 表示字符串的结尾
      var regex = /\.xlsx$|\.xls$|\.csv$/i; // 匹配 .xlsx、.xls 或 .csv 结尾的文件
      return regex.test(url);
    },
    handleOk() {
      if (!this.company_id) return this.$message.warning("请选择分包单位");
      if (!this.p) return this.$message.warning("请选择上传文件");
      if (this.batchArray.length == 0)
        return this.$message.warning("请导入数据");
      this.confirmLoading = true;
      batchAdd({ company_id: this.company_id, array: this.batchArray })
        .then((res) => {
          this.p = "";
          this.batchArray = [];
          const h = this.$createElement;
          this.$success({
            centered: true,
            title: "导入操作结果",
            getContainer: ()=> document.getElementById("bodyContnet"),
            // JSX support
            content: h("div", {}, [
              h("div", "成功导入数据条数：" + res.data.affectedRows),
              h(
                "div",
                "失败导入数据条数：" + res.data.warningCount + "(当前项目下身份证号码已存在)"
              ),
            ]),
          });
        })
        .finally(() => {
          this.confirmLoading = false;
          this.$emit("ok");
        });
    },
    handleCancel() {
      this.visible = false;
      this.company_id = undefined;
      this.batchArray = [];
    },
    downloadFile() {
      const data = {};
      personFileBatch.forEach((v) => {
        data[v.value] = "";
      });
      saveExcel([data], "人员导入模板");
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.downloadFile {
  font-size: 12px;
  color: #011733;
  margin-top: 15px;
  cursor: pointer;
  display: inline-block;
}
.content {
  display: flex;
}
.content1 {
  width: 100%;
  min-width: 400px;
  max-width: 400px;
}
.content2 {
  width: 300px;
  margin-left: 20px;
  max-height: 80vh;
  overflow-y: auto;
}

.description {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left {
  width: 80%;
}
.del {
}
</style>